import 'whatwg-fetch';

export const UNAUTHORIZED_EVENT = 'dav:unauthorized';

function notifyUnauthorized() {
  if (typeof window !== 'undefined' && window.dispatchEvent) {
    window.dispatchEvent(new Event(UNAUTHORIZED_EVENT));
  }
}

function send(method, url, token, data, abortSignal = null) {
  const options = {
    method: method,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  };
  if (token) options.headers['Authorization'] = `Bearer ${token}`;

  if (data) options['body'] = JSON.stringify(data);
  if (abortSignal) options['signal'] = abortSignal;
  return request(url, options);
}

function parse(response) {
  return response.json();
}

async function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
  if (response.status === 401) {
    notifyUnauthorized();
  }
  const error = new Error(response.statusText);
  error.status = response.status;
  try {
    error.response = await parse(response);
  } catch (e) {}
  throw error;
}

export default function request(url, options) {
  return fetch(url, options).then(checkStatus).then(parse);
}

export function get(url, token = null, data = null, abortSignal = null) {
  if (data !== null) {
    url +=
      (url.indexOf('?') >= 0 ? '&' : '?') +
      Object.keys(data)
        .map((k) => encodeURIComponent(k) + '=' + encodeURIComponent(data[k]))
        .join('&');
  }
  return send('GET', url, token, null, abortSignal);
}

export function post(url, data, token = null, abortSignal = null) {
  return send('POST', url, token, data, abortSignal);
}

export function put(url, data, token = null, abortSignal = null) {
  return send('PUT', url, token, data, abortSignal);
}

export function del(url, token = null, abortSignal = null) {
  return send('DELETE', url, token, abortSignal);
}



// WEBPACK FOOTER //
// ./src/app/services/request/index.js